// import { url, port } from "../../config/config";

// const downloadFile = (file: any) => {
// 	const a: HTMLAnchorElement = document.createElement("a");
// 	a.href = file.originalname
// 		? window.URL.createObjectURL(new Blob([`${url}:${port}/api/v1/show-file/${file.filename}`]))
// 		: URL.createObjectURL(file);
// 	a.download = file.originalname ? file.originalname : file.name;
// 	document.body.appendChild(a);
// 	a.click();
// 	document.body.removeChild(a);
// };

// export default downloadFile;

import { url, port } from "../../config/config";

const downloadFile = (file: any, fileName: string | null = null) => {
	// console.log("file", file);
	const a: HTMLAnchorElement = document.createElement("a");
	a.href = file.originalname
		? window.URL.createObjectURL(new Blob([`${url}:${port}/api/v1/show-file/${file.filename}`]))
		: file;
	const newFileName = fileName ? fileName : "File";

	a.download = file.originalname ? file.originalname : newFileName;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};

export default downloadFile;

// const downloadFile = (file: any) => {
// 	const a: HTMLAnchorElement = document.createElement("a");
// 	a.href = file;
// 	a.download = "Health Plan Brochure";
// 	document.body.appendChild(a);
// 	a.click();
// 	document.body.removeChild(a);
// };

// export default downloadFile;

export const downloadBrochureFile = (base64Data: any, filename: any) => {
	const link = document.createElement("a");
	const blob = new Blob([Uint8Array.from(atob(base64Data), (c: any) => c.charCodeAt(0))]);
	link.href = URL.createObjectURL(blob);
	link.download = filename;
	link.click();
};
